// Screens split off the Side Bar "Users" privilege (owner 11-03). Each has its
// own Side Bar privilege (privileges rows "Rooms", "Form Settings",
// "Vocabulary"; App.js maps the user's ids to names per practice), and the
// "Users" privilege keeps all three, so user administrators lose nothing.
// Until a practice has the new row nobody holds its name, so the rule is
// exactly the old one ("Users"). The servers check the same (v2
// api/users/authz.screen_allowed, formwiz is_form_settings_admin, BlinkScribe
// practice_vocabulary.is_practice_admin).
export const USERS_PRIVILEGE = "Users";
export const SCREEN_PRIVILEGES = Object.freeze({
  rooms: "Rooms",
  formSettings: "Form Settings",
  vocabulary: "Vocabulary",
});

// The Side Bar privilege names that open a screen: its own, then "Users".
export const screenPrivileges = (screen) =>
  SCREEN_PRIVILEGES[screen] ? [SCREEN_PRIVILEGES[screen], USERS_PRIVILEGE] : [USERS_PRIVILEGE];

export const holdsAny = (held, names) =>
  Array.isArray(held) && Array.isArray(names) && names.some((p) => held.includes(p));

export const holdsScreen = (held, screen) => holdsAny(held, screenPrivileges(screen));

// A route (or nav item) is open: privilegeAny (any one of them) when given,
// else privilege (that one), else open.
export const routeAllowed = (route, held) => {
  if (!route) return true;
  if (Array.isArray(route.privilegeAny) && route.privilegeAny.length) return holdsAny(held, route.privilegeAny);
  return !route.privilege || (Array.isArray(held) && held.includes(route.privilege));
};
